import FlightFeeList from "./FlightFeeList";

function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <FlightFeeList />
    </div>
  );
}

export default App;
